"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.getEnvironmentExperimentFlag = void 0;

const getEnvironmentExperimentFlag = () => {
  const zolaEnv = process.env && (process.env.ZOLA_ENV || process.env.NODE_ENV);

  switch (zolaEnv) {
    case 'development':
      return 'development';

    case 'staging':
      return 'staging';

    case 'production':
    default:
      return 'production';
  }
};

exports.getEnvironmentExperimentFlag = getEnvironmentExperimentFlag;

const getEnvironment = () => {
  return getEnvironmentExperimentFlag().toString();
};

var _default = getEnvironment;
exports.default = _default;